<template>
  <div>
    <h3>Bank Verification Completed</h3>
    <p>
      Congrats! You verified your account. Please wait while we validate your
      identity and crunch some numbers...
    </p>
    <div class="buttons is-right">
      <!-- <a class="button is-link padded-button next-button is-loading" @click="next">Continue</a> -->
      <a
        class="button is-link padded-button next-button is-loading"
        @click="next"
        >Continue</a
      >
    </div>
  </div>
</template>

<script>
import Input from "@/components/shared/Input";
import $ from "jquery";
export default {
  name: "FinicityResult",
  components: {},
  props: {
    customerId: String
  },
  data() {
    return {
      obj: "financials",
      inputs: {
        ts: ""
      }
    };
  },
  mounted: function() {
    var self = this;
    $.ajax({
      type: "POST",
      url: "/api/apply/determine-eligibility",
      contentType: "application/json",
      dataType: "json",
      data: JSON.stringify({ customerId: self.customerId })
    }).done(function(response) {
      console.log("Yay, done!!", response);
      if (response.status){
        self.inputs.ts = response.status
      }
      self.next();
    });
    // setTimeout(this.next, 6000)
  },
  methods: {
    next() {
      this.$emit("next", this.$data);
      console.log(this.$data);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
